import { type ReactNode } from 'react'

import { Box, Dimensions } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

type BoxDimensions = Dimensions | null | undefined

export type LayoutProps = {
  children?: ReactNode
  header?: ReactNode
  footer?: ReactNode
  padding?: BoxDimensions
  paddingX?: BoxDimensions
  paddingY?: BoxDimensions
  paddingTop?: BoxDimensions
  paddingBottom?: BoxDimensions
  paddingLeft?: BoxDimensions
  paddingRight?: BoxDimensions
}

const Layout = ({ children, header, footer, ...props }: LayoutProps) => {
  return (
    <Box
      flexDirection="column"
      height="full"
      maxHeight="full"
      className="flex flex-1 flex-col h-full[&>*]:flex-1"
      {...props}
    >
      {header && (
        <Box paddingLeft="s16" paddingRight="s16">
          {header}
        </Box>
      )}
      <Box flexGrow minHeight="s400" paddingTop={header ? 's16' : 's0'}>
        {children}
      </Box>
      {footer}
    </Box>
  )
}

type CompensationsPayrollRunLayoutProps = {
  children: ReactNode
  header?: LayoutProps['header']
  footer?: LayoutProps['footer']
  onActionClick?: (key: string) => void
}

const CompensationsPayrollRunLayout = ({
  children,
  header,
  footer,
  onActionClick,
}: CompensationsPayrollRunLayoutProps) => {
  return (
    <>
      {/* This is a hack to make the page full height and to use the responsive page body to get the header action clicks*/}
      <Box className="hidden">
        <ResponsivePage.Body variant="fullscreen" onActionClick={onActionClick}>
          &nbsp;
        </ResponsivePage.Body>
      </Box>
      <Layout header={header} footer={footer}>
        {children}
      </Layout>
    </>
  )
}

export { CompensationsPayrollRunLayout }
